import React from "react";

import { SOIL_SIGHT_FLOW_ROUTES } from "consts";

import ScenarioAnalysis from "pages/app/scenario-analysis/ScenarioAnalysis";
import { useSoilSightFlowRedirect } from "pages/app/scenario-onboarding/hooks/useSoilSightFlowRedirect";

export const ScenarioAnalysisGate = () => {
  const { isHolding } = useSoilSightFlowRedirect(SOIL_SIGHT_FLOW_ROUTES.scenarios);

  if (isHolding) {
    return null;
  }

  return <ScenarioAnalysis />;
};

export default ScenarioAnalysisGate;
